import React from 'react';
import { onClickBtnStartTracking } from 'actions/library/item';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import ItemInventoryAlertField from './ItemInventoryAlertField';

class ItemInventoryAlertFieldArray extends React.Component {
  render() {
    const { fields, disabled, classButton } = this.props;
    let isTrack = false;
    const ItemInventoryAlert = [];
    fields.forEach((member, index, fields) => {
      const fieldValues = fields.get(index);
      if (fieldValues.track_stock) {
        isTrack = true;
        ItemInventoryAlert.push(
          <ItemInventoryAlertField
            member={member}
            key={index}
            isEditable={fieldValues.is_editable}
          />
        );
      }
    });
    return (
      <div className="row">
        {!disabled && isTrack && (
          <span className="col-sm-offset-8 col-sm-4 text-left pl-0px label-instock">
            IN STOCK
          </span>
        )}
        {!disabled ? ItemInventoryAlert : []}
        <div className="form-group col-sm-12">
          <button
            onClick={e => {
              this._onClickStartTracking(e, isTrack);
            }}
            className={`btn btn-primary btn-block no-border-radius-top ${
              disabled ? classButton : ''
            }`}
            disabled={disabled}
          >
            {!isTrack
              ? 'Start Tracking Item Inventory and Alerts'
              : 'Manage Item Inventory and Alerts'}
          </button>
        </div>
      </div>
    );
  }

  _onClickStartTracking = (e, isTrack) => {
    const { dispatch, itemForm } = this.props;
    dispatch(onClickBtnStartTracking(itemForm, isTrack));
    e.stopPropagation();
    e.preventDefault();
  };
}

function mapStateToProps(state) {
  return {
    itemForm: getFormValues('item')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemInventoryAlertFieldArray);
